import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { ChevronDown } from 'react-feather';
import { Row, Col, Card, Input, Button } from 'reactstrap';
import { getUsersList, usersSelector } from '../../../../redux/users';
import columns from './columns';
import { Link } from 'react-router-dom';

const CustomHeader = ({ setSearchQuery }) => {
  return (
    <div className="w-100 me-1 ms-50 mt-2 mb-75">
      <Row>
        <Col xl="6" className="d-flex align-items-center p-0">
          <div className="d-flex align-items-center w-100">
            Users
          </div>

        </Col>
        <Col
          xl="6"
          className="d-flex align-items-sm-center justify-content-xl-end justify-content-start flex-xl-nowrap flex-wrap flex-sm-row flex-column pe-xl-1 p-0 mt-xl-0 mt-1">
          <div className="d-flex align-items-center mb-sm-0 mb-1 me-1">
            <label className="mb-0" htmlFor="search">
              Search:
            </label>
            <Input className="ms-50 w-100" type="text" onChange={e => setSearchQuery(e.target.value)} />
          </div>

          <div className="d-flex align-items-center table-header-actions">
            <Link to="/admin/create">
              <Button className="add-new-user" color="primary">
                Add New User
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
    </div>
  );
};

import { useState } from 'react';

const UsersList = () => {
  const dispatch = useDispatch();
  const users = useSelector(usersSelector);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    dispatch(getUsersList());
  }, []);


  const filteredUsers = users.filter(user => {
    const fullName = user.username.toLowerCase();
    return fullName.includes(searchQuery.toLowerCase());
  });

  return (
    <Card className="overflow-hidden">
      <div className="react-dataTable">
        <DataTable
          noHeader
          subHeader
          pagination
          responsive
          columns={columns}
          sortIcon={<ChevronDown />}
          className="react-dataTable"
          data={filteredUsers}
          subHeaderComponent={<CustomHeader setSearchQuery={setSearchQuery} />}
        />
      </div>
    </Card>
  );
};

export default UsersList;
